import firebase from 'firebase';

const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyAUMkOzlZSa3Iuq0K-Vu4t6B9I-soDZhYg",
    authDomain: "facebook-messenger-clone-4a6cc.firebaseapp.com",
    databaseURL: "https://facebook-messenger-clone-4a6cc.firebaseio.com",
    projectId: "facebook-messenger-clone-4a6cc",
    storageBucket: "facebook-messenger-clone-4a6cc.appspot.com",
    messagingSenderId: "509720532378",
    appId: "1:509720532378:web:f47fdd37fa265cc4c71623",
    measurementId: "G-7W1E1199RF"

});

const db = firebaseApp.firestore();

export default db;
